/**
 * Builds filter parameters for API requests by converting the input object into a format
 * that matches the API's expected query parameters structure.
 *
 * - Arrays are converted to `filter[key][]` format.
 * - Non-empty values are kept as they are.
 * - Empty or falsy values are ignored.
 *
 * @param params - The input object containing filter criteria.
 * @param paramMappings - The input object containing mapping keys rules to match api crietieria ex:- [request_status] key should be param filter[status]  in one api
 * @param nestingRules - The input object containing nesting param mapping  ex:- filter[last_status][early_dismissal_request]: pending
 * @returns An object with the formatted filter parameters.
 */

export function buildFilterParams(
    params: any,
    paramMappings: Record<string, string> = {},
    nestingRules: Record<string, { prefix: string; dynamicKeyFrom: string }> = {},
    showFilterPrefix: boolean = true
): { [key: string]: string | string[] } {
    console.log('buildFilterParams:', params);

    const filterParams: { [key: string]: string | string[] } = {};

    Object.keys(params).forEach((key) => {
        // Check for nesting rules
        if (nestingRules[key]) {
            const { prefix, dynamicKeyFrom } = nestingRules[key];
            const dynamicKey = params[dynamicKeyFrom];

            if (dynamicKey !== undefined) {
                filterParams[`${prefix}[${dynamicKey}]`] = params[key];
            }
        } else {
            // Apply paramMappings if available
            const mappedKey = paramMappings[key] || key;

            // Handle arrays as `filter[key][]`
            if (Array.isArray(params[key])) {
                if (showFilterPrefix) {
                    filterParams[`filter[${mappedKey}][]`] = params[key];
                } else {
                    filterParams[`${mappedKey}[]`] = params[key];
                }
            } else if (params[key] !== null && params[key] !== undefined && params[key] !== '' && params[key] !== 'all-statuses') {
                filterParams[mappedKey] = params[key];
            }
        }
    });

    return filterParams;
}

